export default __webpack_public_path__ + "static/media/counter_placeholder.84878a2f.svg";